<template>
	<div>
		<div class="device-mobile" v-if="isMobile">
			<div class="main">
				<div class="navbar">
					<img @dragstart.prevent src="@/assets/topLeftImg.png" alt="" class="logo" @click="toTopImg(0)">
					<img @dragstart.prevent src="@/assets/002.png" alt="" class="search">
					<img @dragstart.prevent src="@/assets/003.png" alt="" class="menu" @click="isMenuShow = true">
				</div>
				<div class="navbar-placeholder"></div>
				<div class="banner" style="width: 100vw;height:53.333333vw;" v-if="isActive('/home')">
					<el-carousel trigger="click" height='53.333333vw'>
						<el-carousel-item v-for="(item, index) in bannerImgList" :key="index"
							style="height:53.333333vw;">
							<img @dragstart.prevent :src="webImg + item.bannerImg + imgCut(1000, 530, 'r')" alt=""
								srcset="" style="width: 100vw;!important; height:53.333333vw;object-fit: fill;">
						</el-carousel-item>
					</el-carousel>
				</div>
				<div
					v-if="
						(isActive('/aboutUs') || 
						isActive('/qualificationHonor') || 
						isActive('/newsCenter') || 
						isActive('/performance') || 
						isActive('/jobPosting') || 
						isActive('/contactUs') || 
						isActive('/feedback') || 
						isActive('/keyProject'))"
					>
					<div style="width: 100vw;height:45.066666vw;position: relative;">
						<img @dragstart.prevent
							v-if="posterImgList.some(item => isActive(item.pagePath))"
							:src="webImg + posterImgList.find(item => isActive(item.pagePath)).frontImg" alt=""
							style="width: 100vw;height:45.066666vw;">
						<div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);color: #fff;width: 90%;">
							<div style="font-size: 24px;font-weight: bold;">{{ posterImgList.find(item => isActive(item.pagePath)).title }}</div>
							<div style="font-size: 14px;margin-top: 10px;">{{ posterImgList.find(item => isActive(item.pagePath)).subtitle.toUpperCase() }}</div>
						</div>
					</div>

				</div>
				<router-view />
				<div class="foot">
					<div class="footOne" v-if="isActive('/home')">
						<div class="footOneItem" @click="footClick(0)"><img @dragstart.prevent
								src="../../src/assets/footOneImg1.png" alt="">
							<div class="footText">公司简介
							</div>
						</div>
						<div class="footOneItem" @click="footClick(1)"> <img @dragstart.prevent
								src="../../src/assets/footOneImg2.png" alt="">
							<div class="footText">资质荣誉
							</div>
						</div>
						<div class="footOneItem" @click="footClick(2)"><img @dragstart.prevent
								src="../../src/assets/footOneImg3.png" alt="">
							<div class="footText">业主反馈
							</div>
						</div>
						<div class="footOneItem" @click="footClick(3)"><img @dragstart.prevent
								src="../../src/assets/footOneImg4.png" alt="">
							<div class="footText">重点项目
							</div>
						</div>
					</div>
					<img @dragstart.prevent src="../../src/assets/footBanner.png" alt="" class="footTwoImg">
					<div class="footFour">
						<div class="row-1" style="cursor: pointer;"><a @click="copyrightClick()">版权声明</a>
							<div class="line">｜</div>
							<a @click="contactUsClick()" style="cursor: pointer;">联系我们</a>
						</div>
						<div class="row-2">版权所有:合肥通安工程机械设备监理有限公司</div>
						<div><a href="https://beian.miit.gov.cn/#/Integrated/index">备案序号:皖ICP备05011731号</a> <a
								href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=34010402702351"
								style="margin-left: 10px;">皖公网安备 34010402702351号</a></div>
					</div>
					<div class="menu-modal" v-if="isMenuShow" @click="isMenuShow = false">
						<div class="menu-modal-content" @click.stop>
							<div class="header">
								<img @dragstart.prevent src="@/assets/home.png" alt="" class="home"
									@click="toTopImg(0)">
								<div class="txt" @click="toTopImg(0)">首页</div>
								<div class="close" @click="isMenuShow = false"> <i class="el-icon-close"></i></div>
							</div>
							<div class="menu-list">
								<div class="yiji-item" v-for="(item, index) in navBarList" :key="index">
									<div class="content" @click="navMouseEnter(index)">
										<img @dragstart.prevent src="@/assets/004.png" alt="" class="dot">
										<div class="title">{{ item.menuName }}</div>
										<img @dragstart.prevent src="@/assets/006.png" alt="" class="arrow-down"
											v-if="index == enterCount && item.path != '/home' && item.path != '/jobPosting' && item.path != '/contactUs'">
										<img @dragstart.prevent src="@/assets/005.png" alt="" class="arrow-right"
											v-else>
									</div>
									<div class="erji-item" v-if="enterCount == index"
										v-for="(item1, index1) in chooseList" @click.stop="chooseClick(index1)">
										<div class="txt" v-if="true">{{ item1.menuName }}</div>
										<div class="txt" v-if="false">{{ item1.title }}</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="device-pc" v-else>
			<div class="main">
				<div class="top">
					<img src="../assets/topLeftImg2.png" alt="" class="topLeftImg" @click="toTopImg(0)"
						@dragstart.prevent>
					<div class="right-top">
						<div class="email-link" @click="openMailLink()">公司邮箱</div>
						<div class="shuxian"></div>
						<div class="xinxipingtai-link" @click="openXinxipingtaiLink()">信息平台</div>
					</div>
					<!-- <img src="../assets/topRightImg.png" alt="" class="topRightImg" @click="toTopImg(1)"
						@dragstart.prevent> -->
				</div>
				<!-- @mouseleave="enterShow = false" -->
				<div class="navBar" @mouseleave="enterShow = false; enterCount = -1">
					<div class="navBarItem" :class="{'active': $route.path == item.path}" @click="navBarClick(index)" @mouseenter.stop="navMouseEnter(index)"
						v-for="(item, index) in navBarList" :key="index">
						<div> {{ item.menuName }}</div>
						<div class="choose" v-if="(enterCount == index && enterShow)">
							<div @click.stop="chooseClick(index1)" class="chooseItem"
								:class="{ chooseItem1: chooseCount == index1 }" v-for="(item1, index1) in chooseList">
								<span v-if="true">{{
									item1.menuName
								}}</span>
								<span v-if="false">{{ item1.title
								}}</span>
							</div>
						</div>
					</div>
					<input type="text" placeholder="搜索" v-model="search" class="search" @keydown="searchInput($event)">
				</div>
				<div class="banner" style="width: 100vw;height:25.17vw;" v-if="isActive('/home')">
					<el-carousel trigger="click" height='25.17vw'>
						<el-carousel-item v-for="(item, index) in bannerImgList" :key="index" style="height:25.17vw;">
							<img @dragstart.prevent :src="webImg + item.bannerImg + imgCut(1920, 251, 'r')" alt=""
								srcset="" style="width: 100vw;!important; height:25.17vw;">
						</el-carousel-item>
					</el-carousel>
				</div>
				<div
					v-if="
						(isActive('/aboutUs') || 
						isActive('/qualificationHonor') || 
						isActive('/newsCenter') || 
						isActive('/performance') || 
						isActive('/jobPosting') || 
						isActive('/contactUs') || 
						isActive('/feedback') || 
						isActive('/keyProject'))"
					>
					<div style="width: 100vw;height:25.17vw;position: relative;">
						<img @dragstart.prevent
							v-if="posterImgList.some(item => isActive(item.pagePath))"
							:src="webImg + posterImgList.find(item => isActive(item.pagePath)).frontImg" alt=""
							style="width: 100vw;height:25.17vw;">
						<div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);color: #fff;width: 1300px;">
							<div style="font-size: 44px;font-weight: bold;">{{ posterImgList.find(item => isActive(item.pagePath)).title }}</div>
							<div style="font-size: 27px;margin-top: 10px;">{{ posterImgList.find(item => isActive(item.pagePath)).subtitle.toUpperCase() }}</div>
						</div>
					</div>

				</div>
				<!-- <div v-if="isActive('/feedback')">
					<div style="width: 100vw;height:25.17vw;">
						<img @dragstart.prevent src="../../src/assets/feedbackBg.png" alt=""
							style="width: 100vw;height:25.17vw;">
					</div>
				</div>
				<div v-if="isActive('/keyProject')">
					<div style="width: 100vw;height:25.17vw;">
						<img @dragstart.prevent src="../../src/assets/keyProjectBg.png" alt=""
							style="width: 100vw;height:25.17vw;">
					</div>
				</div> -->
				<router-view />

				<div class="foot">
					<div class="footOne" v-if="isActive('/home')">
						<div class="footOneItem" @click="footClick(0)"><img @dragstart.prevent
								src="../../src/assets/footOneImg1.png" alt="">
							<div class="footText">公司简介
							</div>
						</div>
						<div class="footOneItem" @click="footClick(1)"><img @dragstart.prevent
								src="../../src/assets/footOneImg3.png" alt="">
							<div class="footText">资质荣誉
							</div>
						</div>
						<div class="footOneItem" @click="footClick(2)"> <img @dragstart.prevent
								src="../../src/assets/footOneImg2.png" alt="">
							<div class="footText">业主反馈
							</div>
						</div>
						<a class="footOneItem" @click="footClick(3)">
							<img @dragstart.prevent src="../../src/assets/footOneImg4.png" alt="">
							<div class="footText">重点项目
							</div>
						</a>
					</div>
					<img @dragstart.prevent src="../../src/assets/footBanner.png" alt="" class="footTwoImg">
					<div class="footThree">
						<div class="link">友情链接</div>
						<div style="margin-left: 40px;">
							<el-select v-model="value" placeholder="相关单位" @change=change>
								<!-- <div v-infinite-scroll="load" style="overflow:auto;height: 100px;"> -->
								<el-option v-for="item in options" :key="item.id" :label="item.unitName" :value="item">
								</el-option>
								<!-- </div> -->
							</el-select>
						</div>

					</div>
					<div class="footFour">
						<div style="cursor: pointer;"><a @click="copyrightClick()">版权声明</a> ｜
							<a @click="contactUsClick()" style="cursor: pointer;">联系我们</a>
						</div>
						<div>版权所有:合肥通安工程机械设备监理有限公司</div>
						<div><a href="https://beian.miit.gov.cn/#/Integrated/index">备案序号:皖ICP备05011731号</a> <a
								href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=34010402702351"
								style="margin-left: 10px;">皖公网安备 34010402702351号</a></div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {
	menu,
	bannerList,
	posterList,
	menuAll,
	performanceCategory,
	unitList,
	unitBelowList
} from '../api/api'
export default {
	name: 'mainTemplate',
	data() {
		return {
			bannerImgList: [],
			posterImgList: [],
			show: false,
			navBarList: [],
			count: 0,
			chooseCount: -1,
			options: [],
			optionsChildren: [],
			value: '',
			valueChildren: '',
			chooseList: [],
			unitBelowList: [],
			search: '',
			enterShow: false,
			enterCount: -1,
			isMenuShow: false,
			chooseMenuList: [],
			route: [
				'/aboutUs',
				'/newsCenter',
				'/vocational',
				'/construct',
				'/investor',
				'/contactUs'
			],

		}
	},
	created() {
		this.$store.commit('changeScreenWidth')
		// 监听页面尺寸
		window.addEventListener('resize', () => {
			this.$store.commit('changeScreenWidth')
		});
		// 监听页面滚动
		window.onscroll = () => {
			// 发送滚动事件
			this.$bus.$emit('windowOnscroll')

			// 监听滚动到底部
			if (this.$global.reachBottom(0)) {
				console.log("滚动到底部了");
				this.$bus.$emit('reachBottom');
			}
		};

		if (this.$route.query.index) {
			this.count = this.$route.query.index
		}

		this.getBannerList() //首页轮播图
		this.getPosterList() //海报列表
		this.getMenuAll() //首页轮播图
		this.getUnitList() //友情链接
		this.getUnitBelowList() //友情链接
		console.log("this.count: ", this.count);
	},

	watch: {
		$route(to, from) {
			console.log(to.query.index, 'to');
			this.count = to.query.index
			console.log("this.count: ", this.count);
		},
		isMenuShow(val) {
			console.log("val: ", val);
			this.$global.stopPageScroll(val)
		}
	},
	methods: {
		openMailLink() {
			window.open('http://mail.hgmrita.com', '_blank');
		},
		openXinxipingtaiLink() {
			window.open('http://218.22.25.57:56788', '_blank');
		},
		//首页轮播图
		getBannerList() {
			bannerList().then(res => {
				console.log(res, 'res');
				this.bannerImgList = res.data
			})
		},
		//海报列表
		getPosterList() {
			posterList().then(res => {
				console.log(res, 'res');
				res.data.forEach(item => {
					item.frontImg = item.posterImage
					switch (item.pagePath) {
						case '/aboutUs':
							item.title = '公司简介'
							item.subtitle = 'About Us'
							break;
						case '/qualificationHonor':
							item.title = '资质荣誉'
							item.subtitle = 'Qualifications & Honors'
							break;
						case '/newsCenter':
							item.title = '企业新闻'
							item.subtitle = 'Corporate News'
							break;
						case '/performance':
							item.title = '公司业绩'	
							item.subtitle = 'Track Record'
							break;
						case '/jobPosting':
							item.title = '人才招聘'
							item.subtitle = 'Careers'
							break;
						case '/contactUs':
							item.title = '联系我们'
							item.subtitle = 'Contact Us'
							break;
						case '/feedback':
							item.title = '业主反馈'
							item.subtitle = 'Track Record'
							break;
						case '/keyProject':
							item.title = '重点项目'
							item.subtitle = 'Major Projects'
							break;
						default:
							break
					}
				})
				this.posterImgList = res.data
			})
		},
		//首页链接
		toTopImg(index) {
			if (index == 0) {
				this.$router.push({
					path: '/home',
					query: {
						index: index
					}
				})
			} else {
				location.href = 'http://www.hgmri.com/'
			}
			this.isMenuShow = false
		},
		//查询所有菜单
		getMenuAll() {
			// menuAll().then(res => {
			// 	this.navBarList = res.data

			// 	for (let i = 0; i < this.navBarList.length; i++) {
			// 		this.navBarList[i].route = this.route[i]
			// 	}
			// 	console.log(this.navBarList, 'this.navBarList');
			// 	this.getMenu(0)
			// 	this.getMenu(1)
			// 	this.getMenu(3)
			// 	this.getMenu(4)
			// 	this.getVocationalList()
			// })

			this.navBarList = [
				{
					menuName: '首页',
					menuId: '',
					path: '/home',
					num: 0
				},{
					menuName: '公司简介',
					menuId: '',
					path: '/aboutUs',
					num: 0
				},{
					menuName: '资质荣誉',
					menuId: '',
					path: '/qualificationHonor',
					num: 0
				},{
					menuName: '企业新闻',
					menuId: '',
					path: '/newsCenter',
					num: 0
				},{
					menuName: '公司业绩',
					menuId: '',
					path: '/performance',
					num: 0
				},{
					menuName: '人才招聘',
					menuId: '',
					path: '/jobPosting',
					num: 0
				},{
					menuName: '联系我们',
					menuId: '',
					path: '/contactUs',
					num: 0
				},
			]
			this.chooseMenuList = [
				[],
				[{
					menuName: '公司简介',
					menuId: '',
					path: '/aboutUs',
					num: 0
				},{
					menuName: '公司资质',
					menuId: '',
					path: '/qualificationHonor',
					num: 0
				},{
					menuName: '公司荣誉',
					menuId: '',
					path: '/qualificationHonor',
					num: 1
				},{
					menuName: '联系我们',
					menuId: '',
					path: '/contactUs',
					num: 0
				},],
				[{
					menuName: '公司资质',
					menuId: '',
					path: '/qualificationHonor',
					num: 0
				},{
					menuName: '公司荣誉',
					menuId: '',
					path: '/qualificationHonor',
					num: 1
				},],
				[{
					menuName: '企业新闻',
					menuId: '',
					path: '/newsCenter',
					num: 0
				},{
					menuName: '项目动态',
					menuId: '',
					path: '/newsCenter',
					num: 1
				},],
				[],
				[],
				[],
			]
			this.getVocationalList()
		},
		isActive(route) {
			return this.$route.path === route;
		},
		//鼠标移入
		navMouseEnter(index) {
			console.log(index, 'index');
			if (this.enterCount == index) {
				return this.enterCount = -1
			}
			this.enterCount = index
			this.enterShow = true
			this.chooseList = this.chooseMenuList[index]
			console.log(this.chooseList, 'this.chooseList');
			if (this.isMobile) {
				if (
					this.navBarList[index].path == '/home' ||
					this.navBarList[index].path == '/jobPosting' ||
					this.navBarList[index].path == '/contactUs'
				) {
					this.openUrl({
						path: this.navBarList[index].path,
						query: {
							num: 0
						}
					})	
				}
			}
		},
		//查询子菜单
		getMenu(index) {
			menu(this.navBarList[index].menuId).then(res => {
				this.chooseMenuList[index] = res.data
				console.log('res: index', res.data);
			})
		},
		getVocationalList() {
			performanceCategory().then(res => {
				this.chooseMenuList[4] = res.data.map((item, index) => {
					let obj = {}
					obj.menuName = item.title
					obj.menuId = item.id
					obj.path = '/performance'
					obj.num = index
					return obj
				})
				console.log(this.chooseMenuList[4], 'this.chooseMenuList[4]');
			})
		},

		chooseClick(index) {
			this.openUrl({
					path: this.chooseMenuList[this.enterCount][index].path,
					query: {
						// parentId: this.navBarList[this.enterCount].menuId,
						// index: 1,
						num: this.chooseMenuList[this.enterCount][index].num
					}
				})
			return
			if (this.enterCount == 0) {
				this.openUrl({
					path: '/aboutUs',
					query: {
						parentId: this.navBarList[this.enterCount].menuId,
						index: 1,
						num: index
					}
				})
			}
			if (this.enterCount == 1) {
				this.openUrl({
					path: '/newsCenter',
					query: {
						parentId: this.navBarList[this.enterCount].menuId,
						index: 2,
						num: index
					}
				})
			}
			if (this.enterCount == 2) {
				this.openUrl({
					path: '/vocational',
					query: {
						id: this.chooseList[index].id,
						index: 3
					}
				})
			}
			if (this.enterCount == 3) {
				// if (index == 0) {
				this.openUrl({
					path: '/construct',
					query: {
						parentId: this.navBarList[this.enterCount].menuId,
						index: 4,
						num: index
					}
				})
				// } else {
				// 	window.open('http://www.hgmri.com/ddjs/ddesd/ ', '_blank')
				// }

			}
			if (this.enterCount == 4) {
				if (index == 2) {
					window.open('http://www.sse.com.cn/home/search/?webswd=600444', '_blank')
				} else {
					this.openUrl({
						path: '/investor',
						query: {
							parentId: this.navBarList[this.enterCount].menuId,
							index: 5,
							num: index
						}
					})
				}

			}

			if (this.enterCount == 5) {
				this.openUrl({
					path: '/contactUs',
					query: {
						parentId: this.navBarList[index].menuId,
						index: 6
					}
				})
			}
			this.isMenuShow = false
		},
		//查询业务领域列表
		getBusinessList(inx) {
			this.openUrl({
				path: '/vocational',
				query: {
					id: this.chooseMenuList[2][inx].id,
					index: 3
				}
			})
		},
		searchInput(e) {
			if (this.search && e.keyCode == 13) {
				// this.openUrl({ path: '/search', query: { search: this.search } })
				this.openUrl({
					path: '/newsCenter',
					query: {
						parentId: this.navBarList[1].menuId,
						index: 2,
						num: 0,
						search: this.search
					}
				})
			}

		},

		//导航栏
		navBarClick(index) {
			console.log(this.navBarList, 'navBarList');
			console.log(index, 'index');
			this.openUrl({
					path: this.navBarList[index].path,
					query: {
						// parentId: this.navBarList[index].menuId,
						// index: 1,
						num: this.navBarList[index].num
					}
				})
		},
		// 联系我们
		contactUsClick() {
			this.openUrl({
				path: '/contactUs',
				query: {
					num: 0
				}
			})
		},
		//友情链接
		getUnitList() {
			unitList().then(res => {
				this.options = res.data
			})
		},
		getUnitBelowList() {
			unitBelowList().then(res => {
				this.optionsChildren = res.data
			})
		},
		//底部链接
		change(e) {
			this.value = e.unitName
			this.$confirm('是否打开链接')
				.then(_ => {
					this.done(e.unitLink);
				})
				.catch(_ => { });
		},
		done(e) {
			location.href = e
		},
		//底部链接
		change1(e) {
			this.valueChildren = e.belowName
			console.log(111111);
			this.$confirm('是否打开链接')
				.then(_ => {
					this.done(e.belowLink);
				})
				.catch(_ => { });
		},
		footClick(inx) {
			// 公司简介
			if (inx == 0) {
				this.openUrl({
					path: '/aboutUs',
					query: {
						// parentId: this.navBarList[0].menuId,
						// index: 1,
						num: 0
					}
				})
			}
			// 资质荣誉
			if (inx == 1) {
				this.openUrl({
					path: '/qualificationHonor',
					query: {
						// parentId: this.navBarList[0].menuId,
						// index: 1,
						num: 0
					}
				})
			}
			// 业主反馈
			if (inx == 2) {
				this.openUrl({
					path: '/feedback',
					query: {
						// parentId: this.navBarList[0].menuId,
						// index: 1,
						num: 0
					}
				})
				
			}
			// 重点项目
			if (inx == 3) {
				this.openUrl({
					path: '/keyProject',
					query: {
						// parentId: this.navBarList[0].menuId,
						// index: 1,
						num: 0
					}
				})
			}
		},
		copyrightClick() {
			this.openUrl({
				path: '/copyright',
				query: {
					search: this.search,
					index: 0
				}
			})
		}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.device-mobile {
	.main {
		display: flex;
		flex-direction: column;
		align-items: center;
		width: 100vw;
		min-height: 100vh;
		background: #FFFFFF;

		.navbar {
			position: fixed;
			top: 0;
			z-index: 99;
			display: flex;
			align-items: center;
			width: 100%;
			height: 1.333333rem;
			background: #FFFFFF;

			.logo {
				margin-left: 0.266667rem;
				margin-right: auto;
				width: 5.573333rem;
				height: 0.586667rem;
			}

			.search {
				width: 0.493333rem;
				height: 0.493333rem;
			}

			.menu {
				margin-left: 0.706667rem;
				margin-right: 0.453333rem;
				width: 0.453333rem;
				height: 0.426667rem;
			}
		}

		.navbar-placeholder {
			width: 100%;
			height: 1.333333rem;
		}

		.foot {
			margin-top: auto;

			.footOne {
				display: flex;
				flex-direction: column;
				align-items: center;
				margin-bottom: 0.613333rem;

				.footOneItem {
					margin-bottom: 0.266667rem;
					width: 9.466667rem;
					height: 3.2rem;
					position: relative;
					display: flex;
					justify-content: center;
					align-items: center;
					overflow: hidden;

					img {
						width: 100%;
						object-fit: cover;
					}

					.footText {
						position: absolute;
						font-size: 0.48rem;
						font-family: Microsoft YaHei-Bold, Microsoft YaHei;
						font-weight: bold;
						color: #FFFFFF;
					}

					.footOneMore {
						position: absolute;
						top: 0.266667rem;
						right: 0;
						display: flex;
						justify-content: center;
						align-items: center;
						width: 0.906667rem;
						height: 0.586667rem;
						background: #0175C2;

						a {
							font-size: 0.32rem;
							font-family: Microsoft YaHei-Regular, Microsoft YaHei;
							font-weight: 400;
							color: #FFFFFF;
							text-decoration: none;
						}
					}
				}
			}

			.footTwoImg {
				display: flex;
				width: 100%;
				height: 1.2rem;
			}

			.footFour {
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				width: 100%;
				height: 1.866667rem;
				background: #1E243C;
				border-radius: 0px 0px 0px 0px;
				opacity: 1;

				div,
				a {
					font-size: 0.24rem;
					font-family: PingFang SC-Medium, PingFang SC;
					font-weight: 500;
					color: #979FBF;
					text-decoration: none;
				}

				.row-1 {
					display: flex;
					align-items: center;

					.line {
						margin: 0 0.266667rem;
					}
				}

				.row-2 {
					margin: 0.1rem 0;
				}
			}
		}

		.menu-modal {
			position: fixed;
			top: 0;
			right: 0;
			bottom: 0;
			left: 0;
			background-color: rgba(#000000, 0.5);
			z-index: 99;

			.menu-modal-content {
				width: 8rem;
				height: 100%;
				margin-left: auto;
				background: #FFFFFF;
				border-radius: 0px 0px 0px 0px;
				opacity: 1;
				overflow-y: auto;

				.header {
					display: flex;
					align-items: center;
					width: 100%;
					height: 2.4rem;

					.home {
						width: 0.4rem;
						height: 0.4rem;
						margin-left: 0.693333rem;
						margin-right: 0.293333rem;
					}

					.txt {
						margin-right: auto;
						font-size: 0.506667rem;
						font-family: PingFang SC-Bold, PingFang SC;
						font-weight: bold;
						color: #363B4C;
					}

					.close {
						display: flex;
						margin-right: 0.533333rem;

						.el-icon-close {
							font-size: 0.706667rem;
						}
					}
				}

				.menu-list {
					width: 100%;

					.yiji-item {
						width: 100%;

						.content {
							display: flex;
							align-items: center;
							position: relative;
							width: 100%;
							height: 1.333333rem;
							background-color: #FFFFFF;

							.dot {
								position: absolute;
								margin-left: 0.666667rem;
								width: 0.16rem;
								height: 0.16rem;
							}

							.title {
								margin-left: 1.013333rem;
								margin-right: auto;
								font-size: 0.453333rem;
								font-family: PingFang SC-Medium, PingFang SC;
								font-weight: 500;
								color: #363B4C;
							}

							.arrow-down {
								width: 0.373333rem;
								height: 0.32rem;
								margin-right: 0.453333rem;
							}

							.arrow-right {
								width: 0.32rem;
								height: 0.373333rem;
								margin-right: 0.453333rem;
							}
						}

						.erji-item {
							display: flex;
							align-items: center;
							width: 100%;
							height: 1.333333rem;
							background-color: #F7F7F7;

							.txt {
								margin-left: 1.013333rem;
								font-size: 0.4rem;
								font-family: PingFang SC-Medium, PingFang SC;
								font-weight: 500;
								color: #363B4C;
							}
						}
					}
				}
			}
		}
	}
}

.device-pc {
	.main {
		display: flex;
		flex-direction: column;
		align-items: center;
		width: 100vw;
		min-height: 100vh;
		background: #FFFFFF;
	}

	.top {
		width: 1343px;
		// height: 84px;
		display: flex;
		// align-items: center;
		padding-top: 0px;
		// padding-top: 22px;

		.topLeftImg {
			// width: 465px;
			height: 77px;
			cursor: pointer;
		}

		.topRightImg {
			width: 110px;
			height: 29px;
			margin-left: auto;
			cursor: pointer;
		}

		.right-top {
			align-self: center;
			display: flex;
			align-items: center;
			margin-left: auto;
			font-size: 14px;
			color: #0175C2;
			font-weight: bold;
			.email-link {
				cursor: pointer;
			}
			.shuxian {
				margin: 0 10px;
				width: 1px;
				height: 14px;
				background: #cbcbcb;
			}
			.xinxipingtai-link {
				cursor: pointer;
			}
		}

	}

	.navBar {
		width: 1343px;
		// height: 68px;
		// background: red;
		padding-top: 4px;
		padding-bottom: 14px;
		// margin-left: 43px;
		display: flex;
		align-items: center;

		.navBarItem {
			width: 120px;
			height: 40px;
			display: flex;
			justify-content: center;
			align-items: center;
			font-size: 16px;
			font-family: Microsoft YaHei-Bold, Microsoft YaHei;
			font-weight: bold;
			color: #333333;
			cursor: pointer;
			position: relative;
			// margin-right: 50px;
			margin-right: 10px;
			.choose {
				// padding-top: 4px;
				width: 420px;
				// height: 100px;
				box-sizing: border-box;
				position: absolute;
				left: 0;
				top: 40px;
				z-index: 999999;
				background: #FFFFFF;
				display: flex;
				flex-wrap: wrap;
				font-size: 18px;
				font-family: Microsoft YaHei-Regular, Microsoft YaHei;
				font-weight: 400;
				color: #333333;

				.chooseItem {
					// margin-right: 10px;
					// margin-top: 10px;
					padding: 10px 20px;
					border-bottom: 1px dashed #e5e5e5;
					border-top: 1px dashed #e5e5e5;

					span {
						// color: aqua;

					}

					span:hover {
						text-decoration: underline;
					}
				}

				.chooseItem:last-child {
					// border-bottom: 1px dashed #e5e5e5;
				}

				.chooseItem1 {
					background: #0076BE;
					color: #FFFFFF;
				}

				.chooseItem:hover {
					// background: #0076BE;
					// color: #FFFFFF;
				}


			}
		}

		.navBarItem:hover {
			background: #0076BE;
			font-size: 16px;
			font-family: Microsoft YaHei-Bold, Microsoft YaHei;
			font-weight: bold;
			color: #FFFFFF;
		}
		.navBarItem.active {
			background: #0076BE;
			font-size: 16px;
			font-family: Microsoft YaHei-Bold, Microsoft YaHei;
			font-weight: bold;
			color: #FFFFFF;
		}

		.navBarItem1 {
			background: #0076BE;
			font-size: 16px;
			font-family: Microsoft YaHei-Bold, Microsoft YaHei;
			font-weight: bold;
			color: #FFFFFF;
		}

		.search {
			width: 225px;
			height: 36px;
			background: rgba(255, 255, 255, 0.2);
			border-radius: 18px 18px 18px 18px;
			border: 1px solid #0175C2;
			box-sizing: border-box;
			margin-left: auto;
			background: url(../assets/search.png) no-repeat 20px center;
			background-size: 19px 19px;
			padding-left: 50px;
			box-sizing: border-box;
		}
	}

	.foot {
		width: 100vw;
		// background: #FFFFFF;

		.footOne {
			width: 1300px;
			// width: 1200px;
			height: 290px;
			display: flex;
			align-items: center;
			margin: 0 auto;
			cursor: pointer;
			position: relative;

			.footOneMore {
				position: absolute;
				right: 30px;
				top: 60px;
				width: 43px;
				height: 28px;
				// background: #0175C2;
				background: rgba(1, 117, 194, 0.5);
				font-size: 14px;
				font-family: Microsoft YaHei-Bold, Microsoft YaHei;
				font-weight: bold;
				color: #FFFFFF;
				display: flex;
				justify-content: center;
				align-items: center;

				a {
					color: #FFFFFF;
					text-decoration: none;
				}
			}

			.footOneItem {
				position: relative;
				// width: 300px;
				width: 310px;
				height: 200px;
				// background: rgba(0, 0, 0, 0.5);
				overflow: hidden;
				margin-right: 10px;
				// margin-right: 30px;
				// filter: blur(1px) grayscale(.1);
				opacity: .6;
				// background: rgba(255, 255, 255, .6);

				// img {
				//   transition: transform 2s cubic-bezier(.23, 1, .32, 1);
				// }
			}

			.footOneItem:hover {
				opacity: 2;
				// background: rgba(255, 255, 255, 1);

				// background: rgba(0, 0, 0, 1);

				// transform: scaleX(20%);
				// img {
				//   transition: transform 2s cubic-bezier(.23, 1, .32, 1);
				//   transform: scale(1.1);
				// }
			}

			img {
				width: 328px;
				height: 200px;
			}

			.footText {
				font-size: 20px;
				font-family: Microsoft YaHei-Bold, Microsoft YaHei;
				font-weight: bold;
				color: #FFFFFF;
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
			}
		}

		.footTwoImg {
			width: 100vw;
			height: 140px;
		}

		.footThree {
			width: 1300px;
			height: 64px;
			display: flex;
			align-items: center;
			// justify-content: center;
			margin: 0 auto;

			.link {
				font-size: 18px;
				font-family: Microsoft YaHei-Regular, Microsoft YaHei;
				font-weight: 400;
				color: #004EA1;
			}
		}

		.footFour {
			width: 100vw;
			height: 179px;
			background: #0076BE;
			font-size: 14px;
			font-family: Microsoft YaHei-Regular, Microsoft YaHei;
			font-weight: 400;
			color: #FFFFFF;
			display: flex;
			justify-content: center;
			align-items: center;
			flex-direction: column;
			line-height: 30px;

			a {
				color: #FFFFFF;
				text-decoration: none;
			}
		}
	}

	.banner {
		// @media screen and (min-width: 960px) and (max-width: 1200px) {
		//   zoom: .643;
		// }

	}

	.el-carousel__container {
		height: 25.17vw !important;
		height: 5.333333rem;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/main.vue